// Accordions
export { default as Accordions } from "./Accordions";
export type { default as AccordionsProps } from "./AccordionsProps.interface";

// Accordion
export { default as Accordion } from "./components/Accordion/Accordion";
export type { default as AccordionProps } from "./components/Accordion/AccordionProps.interface";